import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FileUpload } from "./file-upload";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

export interface FilePreviewData {
    upload: FileUpload;
    url: URL;
}

@Component({
    selector: 'eas-file-preview',
    templateUrl: 'file-preview.component.html',
    providers: [],
    standalone: false
})
export class FilePreviewComponent {
    url: SafeResourceUrl | undefined;

    isImage: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<FilePreviewComponent>,
        @Inject(MAT_DIALOG_DATA) public data: FilePreviewData,
        private sanitizer: DomSanitizer,
    ) {

    }

    ngOnInit() {
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.url.toString());
        this.isImage = this.data.upload.contentType.startsWith('image/');
    }

}